<template>
  <a-spin :spinning="loading" tip="Processing...">
    <div class="card mb-3" style="min-height: 60vh;">
      <div class="card-body" style="padding-top: 50px;">
        <h3>Job Monitoring</h3>

        <!-- Filter Section -->
        <div class="card">
          <div class="card-body">
            <div class="row mb-3" style="padding: 10px;">
              <div class="col-md-3">
                <label>Import By:</label>
                <a-input v-model="filters.created_by" placeholder="Enter user's first name or last name" @pressEnter="applyFilters"/>
              </div>
              <div class="col-md-3">
                <label>Time Start:</label>
                <a-date-picker v-model="filters.created_at" format="YYYY-MM-DD" placeholder="Select date" style="width: 100%" @change="onDateChange"/>
              </div>
              <div class="col-md-3">
                <label>Status:</label>
                <a-select v-model="filters.status" placeholder="Select status" style="width: 100%" allowClear @change="applyFilters">
                  <a-select-option value="">All</a-select-option>
                  <a-select-option value="D">Done</a-select-option>
                  <a-select-option value="P">Ongoing</a-select-option>
                  <a-select-option value="S">System Error</a-select-option>
                  <a-select-option value="E">With Errors</a-select-option>
                  <a-select-option value="T">Upload Terminated</a-select-option>
                </a-select>
              </div>
              <div class="col-md-3" style="display: flex; align-items: end;">
                <a-button type="primary" @click="applyFilters" style="margin-right: 8px;">
                  Filter
                </a-button>
                <a-button @click="clearFilters">
                  Clear All Filters
                </a-button>
              </div>
            </div>
          </div>
        </div>
        <!-- end of filter section -->

    <div class="col-md-12" style="padding: 10px; height: auto;">
      <a-table :columns="columns" :dataSource="jobList" :pagination="pagination">
        <template slot="download-column" slot-scope="profile_name, record">
          <div v-if="profile_name.includes('full_sync_export') && record.formatted_status === 'Done'">
            <a-button type="primary" @click.prevent="downloadExport(record)">
              Download
            </a-button>
          </div>
          <div v-if="profile_name.includes('General Inventory Report') && record.formatted_status === 'Done'">
            <!-- <a-button @click.prevent="downloadExport(record)">
              
            </a-button> -->
            <a-dropdown slot="extra" >
              <!-- <a-spin :spinning="spinning"> -->
                <a-button type="primary"  @click.prevent="downloadExportReport(record)">
                  Download    
                </a-button>
              <!-- </a-spin> -->
              <!-- <a-menu slot="overlay">
                  <a-menu-item key=1>
                    <a-spin :spinning="spinning1">
                      <a @click.prevent="downloadGiExcelExport(record)">EXCEL</a>
                      <download-excel id='clickExcelExport' hidden :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+fileDate+`.xlsx`" class="float-right"  style=" width: 20%;">
                          <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;"> Download excel </button> &nbsp; &nbsp;
                      </download-excel>
                    </a-spin>
                  </a-menu-item>
                  <a-menu-item key=2>
                    <a-spin :spinning="spinning">
                      <a @click.prevent="downloadGiCsvExport(record)">CSV</a>
                      <vue-json-to-csv :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+fileDate">
                        <button id='clickCsvExport' hidden class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button>
                      </vue-json-to-csv>
                    </a-spin>
                  </a-menu-item>
              </a-menu> -->
            </a-dropdown>
          </div>
          <div v-if="record.export_csv_error != null && record.formatted_status != 'Done'">
            <vue-json-to-csv :json-data=parseCSVError(record.export_csv_error) :csv-title="record.error_file_name">
              <a-button type="primary">
                Download CSV
              </a-button>
            </vue-json-to-csv>
          </div>
          <div v-if="['ORIPOX','ORISOX','RELSLO','RECADJ'].includes(record.profile_name) && record.import_errors != null && record.import_errors.length >= 10">
            <a-button type="primary" @click.prevent="saveFile(record)">
              Download 
            </a-button>
          </div>
        </template>
        <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
          
          <a-list v-if="['ORIPOX','ORISOX','RELSLO','RECADJ'].includes(record.profile_name)" bordered :dataSource="computedObj(record.import_errors)">
            <a-list-item slot="renderItem" slot-scope="item">{{ item }}</a-list-item>
            <div slot="header">Errors</div>
          </a-list>
          <a-list v-else bordered :dataSource="record.import_errors">
            <a-list-item slot="renderItem" slot-scope="item">{{ item }}</a-list-item>
            <div slot="header">Errors</div>
          </a-list>
          <a-list bordered :dataSource="record.import_info">
            <a-list-item slot="renderItem" slot-scope="item">{{ item }}</a-list-item>
            <div slot="header">Info</div>
          </a-list>
        </p>
      </a-table>
      <div class="row pt-3 align-text-bottom">
        <div class="col">
            <a-pagination class="float-right" :current="current" :pageSize="perPage" :total="total" @change="onChange" />
        </div>
      </div>
    </div>
  </div>
  <!-- <div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card mb-3">
                        <div class="col-md-12">
                            <br>
                            <h2>Job Monitoring</h2>
                            <br>
                            <a-table :columns="columns" :dataSource="jobList" :pagination="pagination">
                                <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                                    <a-list bordered :dataSource="record.import_errors">
                                      <a-list-item slot="renderItem" slot-scope="item">{{item}}</a-list-item>
                                      <div slot="header">Errors</div>
                                    </a-list>
                                </p>
                            </a-table>
                            <br><br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
  </div>
  </a-spin>
</template>

<script>

const columns = [
  { title: 'Import By', dataIndex: 'created_by_display', key: 'created_by_display' },
  { title: 'Profile Name', dataIndex: 'profile_name', key: 'profile_name' },
  { title: 'Time Start', dataIndex: 'formatted_created_at', key: 'formatted_created_at' },
  { title: 'Time End', dataIndex: 'formatted_time_end', key: 'formatted_time_end' },
  { title: 'Progress', dataIndex: 'current_status', key: 'current_status' },
  { title: 'Status', dataIndex: 'formatted_status', key: 'formatted_status' },
  { title: "Action", dataIndex: "profile_name", key: "action", scopedSlots: { customRender: "download-column" } }
];

import HTTPRequest from '../controllers/httpRequest.js'
import formatFile from './Basic Sales Reports/Mixins/exportGeneralInventoryReport';
import secureStorage from './../controllers/secureStorage';
import { mapState, mapActions } from 'vuex'
import moment from 'moment';
import axios from "axios";
import VueJsonToCsv from 'vue-json-to-csv';

export default {
  data() {
    return {
      jobList: null,
      columns: columns,
      pagination:false,
      loading: false,
      current: 1,
      total: 0,
      perPage: 10,
      lastPage: 0,
      JsonData:[],
      currentProfile:'',
      fileDate:'',
      spinning:false,
      spinning1:false,
      filters: {
        created_by: '',
        created_at: null,
        status: ''
      }
    }
  },
  mounted: async function () {
    await this.loadJobs()
  },
  computed: {
    ...mapState(['currentProfile', 'parameters', 'serverType', 'endPoint', 'profileId']),
  },
  mixins: [formatFile],
  components: {
    VueJsonToCsv,
  },
  methods: {
    computedObj(object){
      if (object.length>=10){
        return object.slice(0,9)
      }else{
        return object
      }
    },
    buildFilterQuery() {
      let queryParams = new URLSearchParams()
      queryParams.append('per_page', this.perPage)
      queryParams.append('page', this.current)
      
      // add filters if they have values
      if (this.filters.created_by && this.filters.created_by.trim() !== '') {
        queryParams.append('created_by', this.filters.created_by.trim())
      }
      
      if (this.filters.created_at) {
        // format date to YYYY-MM-DD
        const dateStr = moment(this.filters.created_at).format('YYYY-MM-DD')
        queryParams.append('created_at', dateStr)
      }
      
      if (this.filters.status && this.filters.status !== '') {
        queryParams.append('status', this.filters.status)
      }
      
      return queryParams.toString()
    },
    async loadJobs() {
      this.loading = true
      try {
        const queryString = this.buildFilterQuery()
        const jobList = await HTTPRequest.getRequest(this.endPoint + 'import_jobs?' + queryString, null)
        this.jobList = jobList.data
        this.total = jobList.total
        this.lastPage = jobList.last_page
      } catch (error) {
        console.error('Error loading jobs:', error)
      } finally {
        this.loading = false
      }
    },
    async reloadJobs() {
      await this.loadJobs()
    },
    applyFilters() {
      this.current = 1
      this.reloadJobs()
    },
    clearFilters() {
      this.filters = {
        created_by: '',
        created_at: null,
        status: ''
      }
      this.current = 1
      this.reloadJobs()
    },
    onDateChange(date) {
      this.filters.created_at = date
      // auto-apply filter when date changes
      this.applyFilters()
    },
    parseCSVError(data){
      let newCsvData = []

      //Loop Data
      for (let i = 0, len = data[1].length; i < len; i++) {
        var jData = data[1][i];
        var newData ={};

        for (let h = 0, len = data[0].length; h < len; h++) {
          var col = data[0][h]
          newData[col] = (jData[col] == null) ? '': jData[col];
        }
        newData['error'] = jData['error'];
        newCsvData.push(newData)
      }
      return newCsvData;
    },
    async downloadExport(record) {
      const { file_path: urlDownload, profile_name, formatted_time_end } = record
      const downloadLink = await axios({
        method: 'post',
        responseType: 'blob', // important
        url: this.endPoint + "systems/full_sync/download_zip",
        headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") },
        data: { file_path: urlDownload }
      })

      const url = window.URL.createObjectURL(new Blob([downloadLink.data], { type: 'application/zip' }));
      const link = document.createElement('a');
      link.href = url;
      let site_code = profile_name.split("_")
      const extraction_date = formatted_time_end.split(" ")

      link.setAttribute('download', `${site_code[site_code.length - 1]}_full_sync_profiles_${_.snakeCase(extraction_date[0])}.zip`);
      document.body.appendChild(link);

      link.click();
      window.URL.revokeObjectURL(url);
    },
    saveFile(value){
      console.log(value)
      let data = ""
      value.import_errors.forEach(function(obj) {
          data+=obj+"\n"
      });

      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents'),
      a = document.createElement('a');
      const extraction_date = value.formatted_time_end
      let site_code = value.profile_name
      a.download = site_code.replace(/_/g, '-')+'-'+extraction_date.replace(/ /g, '')+".txt";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    },
    onChange(current) {
      this.current = current;
      this.reloadJobs();
    },
    async downloadExportReport(record){
      if(record.cut_off.includes("https")){
        window.open(record.cut_off);
      }else{
        axios({
          url: this.endPoint + 'import_jobs/parse_json_file?filename='+record.cut_off,
          method: "GET",
          responseType: "blob", // important
          headers: {
            Authorization: "Bearer " + secureStorage.getItem("accessToken"),
            "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") 
          },
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var split_filename = record.cut_off.split("/")
          link.setAttribute("download", `${split_filename[split_filename.length-1]}`);
          document.body.appendChild(link);
          link.click();
        });
      }
      // console.log(jobList)
    },
    async downloadGiCsvExport(record){
      this.spinning = true
      var request = new XMLHttpRequest();
      await request.open("GET", record.cut_off, false);
      request.send(null)
      var my_JSON_object = JSON.parse(request.responseText);
      console.log(my_JSON_object)
      // var _data = []
      // await fetch(record.cut_off)
      // .then(response => {
      //     if (!response.ok) {
      //         throw new Error(`HTTP error! Status: ${response.status}`);
      //     }
      //     return response.json();  
      // })
      // .then(data => {
      //   _data = data
      //   console.log(data)
      // })  
      // .catch(error => console.error('Failed to fetch data:', error)); 
      this.JsonData = await this.formatFile(my_JSON_object, record.logs.site_id.split(","), record.logs.isFormat, record.logs.group, record.logs.isSeparate,record.logs.isTI,record.logs.as_of);
      this.fileDate = record.logs.as_of
      this.currentProfile = record.profile_name
      await document.getElementById("clickCsvExport").click()
      this.spinning = false
    },
    async downloadGiExcelExport(record){
      this.spinning1 = true
      
      var my_JSON_object = JSON.parse(request.responseText);
      console.log(my_JSON_object)
      // var jobList = await HTTPRequest.getRequest(this.endPoint + 'import_jobs/parse_json_file?filename='+record.cut_off, null)
      this.JsonData = await this.formatFile(my_JSON_object, record.logs.site_id.split(","), record.logs.isFormat, record.logs.group, record.logs.isSeparate,record.logs.isTI,record.logs.as_of);
      this.fileDate = record.logs.as_of
      this.currentProfile = record.profile_name
      await document.getElementById("clickExcelExport").click()
      this.spinning1 = false
    }
  }
}
</script>

<style scoped>

</style>